import {
  getUserExams,
  getUserExamCategory,
  getUserInfo,
  getUserDeposits,
  getUserTransactions,
  getCityList,
  getWardList,
  postDeposit,
  postCOD
} from "../_api";
import router from "../../../router";

const userExams = async context => {
  context.commit("SET_IS_LOADING_EXAM", true);
  await getUserExams()
    .then(response => {
      context.commit("SET_USER_EXAM_LIST", response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
  context.commit("SET_IS_LOADING_EXAM", false);
};

const userExamCategory = async context => {
  context.commit("SET_IS_LOADING_EXAM", true);
  await getUserExamCategory()
    .then(response => {
      context.commit("SET_USER_EXAM_CATEGORY", response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
  context.commit("SET_IS_LOADING_EXAM", false);
};

const userInfo = async (context, id) => {
  await getUserInfo(id)
    .then(response => {
      context.commit("SET_USER", response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
};

const getTransactions = async context => {
  context.commit("SET_IS_LOADING_TRANSACTION", true);
  await getUserTransactions()
    .then(response => {
      context.commit("SET_USER_TRANSACTION_LIST", response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
  context.commit("SET_IS_LOADING_TRANSACTION", false);
};

const getDeposits = async context => {
  context.commit("SET_IS_LOADING_TRANSACTION", true);
  await getUserDeposits()
    .then(response => {
      context.commit("SET_USER_DEPOSIT_LIST", response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
  context.commit("SET_IS_LOADING_TRANSACTION", false);
};

const getCities = async (context, data) => {
  await getCityList(data)
    .then(response => {
      context.commit("SET_CITY_LIST", response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
};

const getWards = async (context, data) => {
  await getWardList(data)
    .then(response => {
      context.commit("SET_WARD_LIST", response.data);
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
};

const deposit = async (context, data) => {
  context.commit("SET_IS_LOADING_TRANSACTION", true);
  await postDeposit(data)
    .then(response => {
      if (response.data.status == "success") {
        router.push({ name: "user-activity" });
      }
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
  context.commit("SET_IS_LOADING_TRANSACTION", false);
};

const confirmCOD = async (context, data) => {
  context.commit("SET_COD_LOADING", true);
  await postCOD(data)
    .then(response => {
      context.commit("SET_COD_MESSAGE", response.data);
      if (response.data.status == "success") {
        location.reload();
      }
    })
    .catch(({ response }) => {
      if (response && response.data) {
        context.commit("SET_ERROR", response.data.errors);
      }
    });
  context.commit("SET_COD_LOADING", false);
};

export default {
  userExams,
  userExamCategory,
  userInfo,
  getTransactions,
  getDeposits,
  deposit,
  getCities,
  getWards,
  confirmCOD
};
